declare const jobData: any;

import { debounce } from "../index";
import * as JobTypes from "../types/jobData";
import { JobOverviewPage } from "./jobOverviewPage";

/* - Returns Found Jobs with Search Parameters */
export class Search {
  private queryInputs: NodeListOf<HTMLInputElement> | null;
  private locationInputs: NodeListOf<HTMLInputElement> | null;

  private jobOverviewPageInstance: JobOverviewPage;
  private searchCallback: (results: any[]) => void = () => {};

  constructor(jobOverviewPage: JobOverviewPage) {
    this.jobOverviewPageInstance = jobOverviewPage;
    this.queryInputs = document.querySelectorAll(".search-query-job-title") as NodeListOf<HTMLInputElement> | null;
    this.locationInputs = document.querySelectorAll(
      ".search-query-job-location"
    ) as NodeListOf<HTMLInputElement> | null;

    this.addEventListeners();
  }

  private preFillFormUrl() {
    const urlParams = new URLSearchParams(window.location.search); // Get the current URL parameters
    if (this.queryInputs?.length && urlParams.has("title")) {
      this.queryInputs.forEach((element) => {
        element.value = urlParams.get("title") || "";
      });
      console.log("URL Parameter gefunden und queryInput befüllt:", this.queryInputs);
    }

    if (this.locationInputs?.length && urlParams.has("location")) {
      this.locationInputs.forEach((element) => {
        element.value = urlParams.get("location") || "";
      });
      console.log("URL Parameter gefunden und locationInput befüllt:", this.locationInputs);
    }
    // console.log("Search: Prefill Form URL:", this.queryInputs, this.locationInputs);
    this.performSearch();
  }

  // Sets the callback function to be called when search is performed
  OnSearch(callback: (results: any[]) => void) {
    this.searchCallback = callback;
    this.preFillFormUrl(); // Prefill form with URL parameters
  }

  // For Callback
  performSearch() {
    let results: JobTypes.jobData[] = this.filterMatchingJobs(this.jobOverviewPageInstance.getAllJobs); // TODO: Implement search logic here
    
    this.searchCallback(results);
  }

  // For extra Filtering (e.g. on FilterChange Trigger)
  performSearchAndReturn(jobs: JobTypes.jobData[]): JobTypes.jobData[] {
    const results: JobTypes.jobData[] = this.filterMatchingJobs(jobs); // TODO: Implement search logic here
    return results;
  }

  private addEventListeners() {
    if (this.queryInputs?.length) {
      this.queryInputs.forEach((element) => {
        // Debounced Funktion einmal vorher definieren
        const debouncedSearch = debounce(() => this.performSearch(), 500);

        element.addEventListener("input", (event: Event) => {
          const target = event.target as HTMLInputElement;
          const value = target.value;
          // 🔹 Direkt und sofort aufrufen
          this.syncInputValueOnAllInputs(value, target);
          // 🔹 Nur performSearch debounced
          debouncedSearch();
        });
      });
    }

    if (this.locationInputs?.length) {
      this.locationInputs.forEach((element) => {
        const debouncedSearch = debounce(() => this.performSearch(), 300);

        element.addEventListener("input", (event: Event) => {
          const target = event.target as HTMLInputElement;
          const value = target.value;

          this.syncInputValueOnAllInputs(value, target);
          debouncedSearch();
        });
      });
    }
  }

  /** There are multiple input fields for the search query.
   * This method syncs the input value on all input fields.
   *
   * @param value
   * @param target
   */
  private syncInputValueOnAllInputs(value: string, target: HTMLInputElement) {
    if (target.classList.contains("search-query-job-title") && this.queryInputs?.length) {
      this.queryInputs.forEach((element) => {
        if (element !== target) {
          element.value = value;
        }
      });
    } else {
      if (this.locationInputs?.length) {
        this.locationInputs.forEach((element) => {
          if (element !== target) {
            element.value = value;
          }
        });
      }
    }
  }

  /**
   * Filter jobs based on input values
   * Calls also the filterInstance.processJob metho
   *
   */
  private filterMatchingJobs(jobs: JobTypes.jobData[]): JobTypes.jobData[] {
    const query = this.queryInputs?.[0].value?.trim().toLowerCase() || "";
    const location = this.locationInputs?.[0].value?.trim().toLowerCase() || "";

    const foundJobs = jobs.filter((job: JobTypes.jobData) => {
      const matchesQuery =
        !query ||
        job.position.toLowerCase().includes(query) ||
        job.pageTitle.toLowerCase().includes(query) ||
        job.jobOpening.name.toLowerCase().includes(query);

      const locationMatchDirect = job.jobOpening.location?.toLowerCase().includes(location);

      const locationMatchNested = job.jobOpening.locations?.some((loc) => {
        const addr = loc.address;
        return (
          loc.name?.toLowerCase().includes(location) ||
          loc.country?.name?.toLowerCase().includes(location) ||
          addr?.city?.toLowerCase().includes(location) ||
          addr?.country?.name?.toLowerCase().includes(location) ||
          addr?.zipCode?.toLowerCase().includes(location)
        );
      });

      const matchesLocation = !location || locationMatchDirect || locationMatchNested;

      return matchesQuery && matchesLocation;
    });

    // console.log("Search: Found Jobs:", foundJobs);
    return foundJobs;
  }


  getCurrentQuery(): string { 
    return this.queryInputs?.[0].value || "";
  } 

  isActiveSearch(): boolean {
    const query = this.queryInputs?.[0].value || "";
    const location = this.locationInputs?.[0].value || "";

    return query !== "" || location !== ""; // true if any input is filled
  }
}
